//
// DefaultValue.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./ParameterValue";
import "@sas-dvr/ltjs-commons/models/prompt/MissingValueBehavior";

var DefaultValue = createModule("BIRD::DefaultValue", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::ParameterValue"], EventDispatcher, [
    ,
    {
        missingValueBehavior: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default DefaultValue;
